<ng-container *ngIf="text">{{ text | translate }}</ng-container>
<ng-content></ng-content>
